export const parsePhone = (phone?: string) => phone && `+1${phone.replace(/\D/g, '')}`;
